// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__t634h","filesListContainer":"PosDisputesFiles_filesListContainer__314MU","filesButton":"PosDisputesFiles_filesButton__1a6Se"};